import React from "react";

import { DescriptionCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function description({ width, onResize }: Column.Options) {
	return base(ColumnId.Description, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default description;
